import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";
import Cookies from "js-cookie";

const authHeaders = () => ({
  "Content-Type": "application/json",
  "X-CSRF-TOKEN": Cookies.get("csrfToken"),
});

const parseResponse = async (res, fallback) => {
  const text = await res.text();
  const data = text ? JSON.parse(text) : fallback;
  if (!res.ok) {
    throw new Error(data?.message || `Request failed with status ${res.status}`);
  }
  return data;
};

export const getBusinessConfig = async (token, mantisBusinessId) => {
  const res = await apiFetch(
    `${backUrl}/businessConfigurations/${mantisBusinessId}`,
    {
      method: "GET",
      headers: { ...authHeaders(), Authorization: `Bearer ${token}` },
    }
  );

  // A business created before configurations existed simply has no record yet.
  if (res.status === 404) {
    return null;
  }
  return parseResponse(res, null);
};

export const createBusinessConfig = async (token, mantisBusinessId) => {
  const res = await apiFetch(`${backUrl}/businessConfigurations/`, {
    method: "POST",
    headers: { ...authHeaders(), Authorization: `Bearer ${token}` },
    body: JSON.stringify({ mantisBusinessId }),
  });
  return parseResponse(res, null);
};

export const updateBusinessConfig = async (token, mantisBusinessId, config) => {
  const res = await apiFetch(
    `${backUrl}/businessConfigurations/${mantisBusinessId}`,
    {
      method: "PUT",
      headers: { ...authHeaders(), Authorization: `Bearer ${token}` },
      body: JSON.stringify(config),
    }
  );
  return parseResponse(res, null);
};

export const uploadPurchaseRulesDocument = async (
  token,
  mantisBusinessId,
  file,
  fileName
) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = async () => {
      try {
        const config = {
          purchaseRulesDocument: {
            url: "",
            name: fileName || file.name,
            mimeType: file.type,
            base64: reader.result.split(",")[1],
          },
        };
        resolve(await updateBusinessConfig(token, mantisBusinessId, config));
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };

    reader.readAsDataURL(file);
  });
};
